import * as React from 'react'
import { Component } from 'react'

export class DataAsOf extends Component<{}, {}> {
  state = {
    dataThroughDate: ''
  }

  componentDidMount() {
    this.getDataAsOfDate()
  }

  public getDataAsOfDate() {
    const givTitleAndSubtitlePayload = { action: 'getGIVTrendTitleAndSubtitle', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', { method: 'POST', body: JSON.stringify(givTitleAndSubtitlePayload) })
      .then((response) => {
        return response.text()
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&')
        text = text.replace(/\\/g, '')
        return JSON.parse(text)
      })
      .then((json) => {
        this.setState({ dataThroughDate: json.latestMonthYear })
      })
  }

  render() {
    return (
      <header style={{ color: '#333', textAlign: 'right', fontSize: '1.4rem' }}>
        Data through {this.state.dataThroughDate}
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/DataAsOf/index.tsx